import { IonContent, IonAlert, IonPage, IonButton, IonSelect, IonSelectOption } from "@ionic/react";
import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Row, Col, Steps, Form, Input, Button, Statistic, Space, Alert, message, Divider, notification } from "antd";
import { EyeFilled, EyeInvisibleFilled, StarTwoTone, ArrowLeftOutlined } from "@ant-design/icons";

/* Global State*/

import c from "../utils/common";
import moment from "moment-timezone";
import axios from "axios";
import Footer from "../components/footer";
import config from "../data/config";

import { useTranslation } from "react-i18next";
import metaData from "../data/metaData";
import useAuth from "../hooks/useAuth";

const { Countdown } = Statistic;

const ForgotPasswordAdmin = () => {
  const { isEmailExist } = useAuth();
  const history = useHistory();

  let currentPath = window.location.pathname;

  const [step, setStep] = useState(0);
  const [coolDown, setCoolDown] = useState(Date.now() + 1000 * 6);
  const [coolingDown, setCoolingDown] = useState(false);

  const [register_user_type, setRegister_user_type] = useState("admin");

  const [changePwdForm] = Form.useForm();
  const [telephone, setTelephone] = useState();
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [verificationCode, setVerificationCode] = useState();
  const [showTelErrorMsg, setShowTelErrorMsg] = useState(false);
  const [showSentMsg, setShowSentMsg] = useState(false);
  const [showOtpWrongMsg, setShowOtpWrongMsg] = useState(false);
  const [alertVisible, setAlertVisible] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const { t, i18n } = useTranslation();

  const formItemLayout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };

  const tailFormItemLayout = {
    wrapperCol: {
      span: 24,
      offset: 0,
    },
  };

  async function generateVerificationCode() {
    let { email } = changePwdForm.getFieldsValue();
    let exist = await isEmailExist(email);
    console.log(exist);
    if (!exist) {
      setShowTelErrorMsg(true);
    } else {
      setCoolingDown(true);
      setCoolDown(Date.now() + 1000 * 30);

      changePwdForm.setFieldsValue({ otp: null });

      let otp = random4Digit();
      console.log(otp);
      setVerificationCode(otp);

      if (metaData.sendEmail) {
        sendEmail(otp);
      }
    }
  }

  const AlertClosed = () => {
    setAlertVisible(false);
  };

  async function sendEmail(otp) {
    setShowSentMsg(true);
    setShowOtpWrongMsg(false);
    let data = {
      to: changePwdForm.getFieldsValue("email"),
      header: t("register.description_1"),
      otp,
    };
    console.log(data);
    const res = await axios.post(metaData.serverURL + "sendEmail/OTP", data);
    console.log(res);
  }

  function random4Digit() {
    return shuffle("0123456789".split("")).join("").substring(0, 4);
  }

  function shuffle(o) {
    for (var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x);
    return o;
  }

  function validateOtp() {
    let { otp } = changePwdForm.getFieldsValue();
    //console.log(otp + " " + verificationCode)
    if (otp == verificationCode) {
      //save tel
      //console.log(tel)
    } else {
      setShowOtpWrongMsg(true);
      setShowSentMsg(false);
      changePwdForm.setFieldsValue({ otp: null, password: null, repeatPassword: null });
      throw new Error("Verification code incorrect")
    }
  }

  async function finishForm() {
    try {
    validateOtp();

    const email = changePwdForm.getFieldValue("email");
    const password = changePwdForm.getFieldValue("password");

      // Fetch user details
      const userResponse = await axios.post(`${metaData.serverURL}merchantUser/query`, { email });
      console.log(userResponse);

      const hashedPassword = await c.hashPassword(password);

      // Update user password
      const res = await axios.patch(
        `${metaData.serverURL}merchantUser`,
        { password: hashedPassword },
        {
          params: { id: userResponse?.data?.id },
        }
      );
      console.log(res);

      notification.success({ description: "Password updated successfully!" });
      history.push("/login");
    } catch (error) {
      console.error(error);
      notification.error({ description: error.message || "An error occurred" });
      changePwdForm.setFieldsValue({ password: null, repeatPassword: null });
    }
  }

  const validateEmail = async () => {
    try {
      await changePwdForm.validateFields(["email"]);
      setIsEmailValid(true);
    } catch (e) {
      console.log(e.errorFields[0].errors);
      setIsEmailValid(false);
    }
  };

  return (
    <IonPage>
      <ArrowLeftOutlined
        onClick={() => history.goBack()}
        style={{
          textAlign: "left",
          fontSize: "35px",
          width: "5%",
          marginLeft: "25px",
          marginTop: "15px",
        }}
      />
      <IonAlert
        isOpen={showTelErrorMsg}
        onDidDismiss={() => setShowTelErrorMsg(false)}
        message={t("password.NoEmailExist")}
        buttons={[
          {
            text: t("password.Back"),
            handler: () => {
              setShowTelErrorMsg(false);
            },
          },
        ]}
      />
      <Row style={{ padding: "4vw 20vw 30% 20vw", width: "100%" }}>
        <Form
          {...formItemLayout}
          style={{ width: "100%" }}
          form={changePwdForm}
          onFinish={finishForm}
          // onFinishFailed={onchangePwdFormFinishFailed}
        >
          {showSentMsg == true && showOtpWrongMsg == false ? (
            //true
            <Row style={{ marginBottom: "2vw" }}>
              <Col span={24}>
                <Alert
                  message={
                    t("register.Sent-Msg_1.1") + changePwdForm.getFieldValue("email") + t("register.Sent-Msg_1.2")
                  }
                  type="success"
                  closable
                  afterClose={() => {
                    setShowSentMsg(false);
                  }}
                />
              </Col>
            </Row>
          ) : null}
          {showOtpWrongMsg == true && showSentMsg == false ? (
            //true
            <Row style={{ marginBottom: "2vw" }}>
              <Col offset={4} span={20}>
                <Alert
                  message={t("register.Sent-Msg_1.3")}
                  type="error"
                  closable
                  afterClose={() => {
                    setShowOtpWrongMsg(false);
                  }}
                />
              </Col>
            </Row>
          ) : null}

          <Form.Item label={t("register.emailPIC")}>
            <Row gutter={8}>
              <Col span={18}>
                <Form.Item
                  name="email"
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      type: "email",
                      message: t("register.enterEmail"),
                    },
                  ]}
                >
                  <Input
                    onChange={() => {
                      validateEmail();
                    }}
                    size="large"
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                {coolingDown == false ? (
                  <Button size="large" block disabled={!isEmailValid} onClick={generateVerificationCode}>
                    {t("register.getPin")}
                  </Button>
                ) : (
                  <Button size="large" block disabled>
                    <Space>
                      <Countdown
                        valueStyle={{ fontSize: "18px", color: "gray" }}
                        value={coolDown}
                        onFinish={() => {
                          setCoolingDown(false);
                        }}
                        format="ss"
                      />
                      <span>{t("register.second")}</span>
                    </Space>
                  </Button>
                )}
              </Col>
            </Row>
          </Form.Item>

          <Form.Item
            name="otp"
            label={t("register.V_Code")}
            rules={[
              {
                required: true,
                min: 4,
                max: 4,
                message: t("register.Pin_rule1"),
              },
              { pattern: /^\d+$/, message: t("register.Pin_rule2") },
            ]}
          >
            <Input size="large" maxLength={4} />
          </Form.Item>

          <Form.Item
            name="password"
            label={t("password.newpassword")}
            hasFeedback
            rules={[
              {
                required: true,
                min: 9,
                max: 16,
                message: t("register.enterPw"),
              },
              { pattern: /^\S*$/, message: t("register.rule_pw") },
            ]}
          >
            <Input.Password size="large" maxLength={16} />
          </Form.Item>
          <Form.Item
            name="repeatPassword"
            label={t("password.repeatpwd")}
            dependencies={["password"]}
            hasFeedback
            rules={[
              { required: true, message: t("register.reEnterPw") },
              { pattern: /^\S*$/, message: t("register.rule_pw") },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(t("register.unmatchPw")));
                },
              }),
            ]}
          >
            <Input.Password size="large" maxLength={16} />
          </Form.Item>

          <Form.Item {...tailFormItemLayout}>
            <Button disabled={isSubmitting} type="primary" htmlType="submit">
              {t("register.Confirm")}
            </Button>
          </Form.Item>

          {/* <Button type="primary" onClick={() => { setStep(1) }}>next</Button> */}
        </Form>
        <div style={{ width: "100%" }}>
          {alertVisible ? (
            <Alert message={t("password.samepassword")} type="error" showIcon closable afterClose={AlertClosed} />
          ) : null}
        </div>
      </Row>
    </IonPage>
  );
};

export default ForgotPasswordAdmin;
